import * as React from "react";
import classnames from "classnames";
import { SummaryContainer, Button } from "@grandvisionhq/common";
import { Hr } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
import { statusLoading, statusIdle, statusFailed, statusSuccess } from "@grandvisionhq/state";
import CCCHeader from "../../../../../components/CCCHeader/CCC/components/CCCHeader/CCCHeader.js";
import CCCLineItem from "../../../../../components/CCCLineItem/CCC/components/CCCLineItem/CCCLineItem.js";
import CCCLineItemFailed from "../../../../../components/CCCLineItem/CCC/components/CCCLineItem/CCCLineItemFailed.js";
import CCCLineItemLoader from "../../../../../components/CCCLineItem/CCC/components/CCCLineItem/CCCLineItemLoader.js";
import ChangeQuantityModal from "../../../Modals/ChangeQuantity/CCC/Detail/CurrentPlan/Modals/ChangeQuantity/ChangeQuantity.js";
import PauseSubscriptionModal from "../../../Modals/PauseSubscription/CCC/Detail/CurrentPlan/Modals/PauseSubscription/PauseSubscription.js";
/* empty css                 */
class CurrentPlan extends React.Component {
  constructor() {
    super(...arguments);
    this.pauseButtonRef = React.createRef();
    this.editButtonRef = React.createRef();
    this.state = {
      activeModal: void 0
    };
    this.openQuantityModal = () => {
      this.setState({ activeModal: "quantity" });
    };
    this.openPauseModal = () => {
      this.setState({ activeModal: "pause" });
    };
    this.focusModalTrigger = (focusRef) => {
      focusRef.current && focusRef.current.focus();
    };
    this.closeModal = () => {
      const focusRef = this.state.activeModal === "pause" ? this.pauseButtonRef : this.editButtonRef;
      this.setState({ activeModal: void 0 });
      this.focusModalTrigger(focusRef);
    };
    this.handlePause = (duration) => {
      this.props.pause(duration);
    };
    this.handleEdit = (quantity) => {
      this.props.quantity({ quantity });
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (statusLoading(prevProps.pauseCall) && statusIdle(this.props.pauseCall) || statusLoading(prevProps.quantityCall) && statusIdle(this.props.quantityCall)) {
      this.closeModal();
    }
    if (statusLoading(prevProps.pauseCall) && statusFailed(this.props.pauseCall)) {
      this.setState({
        pauseError: this.props.intl.getFormattedLabel("account.ccc.pause.error", {
          parseLink: true
        })
      });
    }
    if (statusFailed(prevProps.pauseCall) && prevState.activeModal && !this.state.activeModal) {
      this.setState({ pauseError: void 0 });
    }
    if (statusLoading(prevProps.quantityCall) && statusFailed(this.props.quantityCall)) {
      this.setState({
        quantityError: this.props.intl.getFormattedLabel("account.ccc.quantity.error", {
          parseLink: true
        })
      });
    }
    if (statusFailed(prevProps.quantityCall) && prevState.activeModal && !this.state.activeModal) {
      this.setState({ quantityError: void 0 });
    }
  }
  render() {
    const {
      subscription,
      className,
      intl,
      productData,
      pauseCall,
      quantityCall,
      handleTopUp,
      reorderLoading,
      getEyeSide
    } = this.props;
    const nextDelivery = subscription.deliveries.find((d) => d.status !== "DELIVERED");
    const price = subscription.billing.totalPricePerInstallment;
    const hasQuantityPending = subscription.pendingChanges.includes("quantity");
    const hasPausePending = subscription.pendingChanges.includes("pause");
    const isSubscriptionDisabled = ["EXPIRED", "CANCELLED", "ON_HOLD"].some(
      (s) => s === subscription.status
    );
    const renderLineItem = (lineItem) => {
      const data = productData[lineItem.productId];
      const { eyeSide } = getEyeSide(lineItem.application);
      if (!data || statusLoading(data)) {
        return /* @__PURE__ */ React.createElement(CCCLineItemLoader, null);
      }
      if (statusFailed(data)) {
        return /* @__PURE__ */ React.createElement(CCCLineItemFailed, null);
      }
      if (statusSuccess(data)) {
        return /* @__PURE__ */ React.createElement(CCCLineItem, { product: data.result, quantity: lineItem.quantity, eyeSide });
      }
    };
    const reorderWarning = intl.getLabel("account.ccc.topUp.description", {
      hideLabelKey: true
    });
    return /* @__PURE__ */ React.createElement("section", { className: classnames("current-plan", className) }, renderStatusAlert(subscription.status, intl), renderPendingChangesAlert(subscription.pendingChanges, intl), /* @__PURE__ */ React.createElement(
      CCCHeader,
      {
        nextDelivery,
        expiryDate: subscription.expiryDate,
        totalPrice: price,
        status: subscription.status,
        disabled: isSubscriptionDisabled,
        className: classnames("current-plan__summary"),
        deliveryFrequency: subscription.deliveryFrequency,
        dueDate: subscription.billing.dueDate
      }
    ), /* @__PURE__ */ React.createElement(SummaryContainer, { className: "current-plan__summary" }, subscription.lineItems.map((lineItem, index) => /* @__PURE__ */ React.createElement(React.Fragment, { key: `${lineItem.productId}-${index}` }, !!index && /* @__PURE__ */ React.createElement(Hr, null), renderLineItem(lineItem)))), subscription.topUpAllowed && reorderWarning && /* @__PURE__ */ React.createElement(
      Alert,
      {
        "data-t": "top-up-description",
        className: "alert-m-default current-plan__topup-description"
      },
      reorderWarning
    ), /* @__PURE__ */ React.createElement("div", { className: "current-plan__buttons" }, subscription.topUpAllowed && /* @__PURE__ */ React.createElement(
      Button,
      {
        "data-t": "top-up",
        className: "current-plan__button",
        caption: intl.getLabel("account.ccc.action.topUp"),
        onClick: reorderLoading ? void 0 : handleTopUp,
        isLoading: reorderLoading,
        disabled: isSubscriptionDisabled
      }
    ), /* @__PURE__ */ React.createElement(
      Button,
      {
        "data-t": "edit-ccc",
        btnRef: this.editButtonRef,
        className: "current-plan__button",
        caption: intl.getLabel("account.ccc.action.edit"),
        onClick: this.openQuantityModal,
        variant: "outline",
        disabled: !subscription.quantityChangeable || hasQuantityPending || isSubscriptionDisabled
      }
    )), /* @__PURE__ */ React.createElement(Hr, null), subscription.pauseOptions.length === 0 && /* @__PURE__ */ React.createElement(Alert, { variant: "info", className: "alert-m-default" }, intl.getFormattedLabel("account.ccc.pause.noBudget", {
      parseLink: true
    })), /* @__PURE__ */ React.createElement(
      Button,
      {
        "data-t": "pause-ccc",
        className: "current-plan__pause-button",
        caption: intl.getLabel("account.ccc.action.pause"),
        onClick: this.openPauseModal,
        btnRef: this.pauseButtonRef,
        variant: "outline",
        disabled: subscription.pauseOptions.length === 0 || hasPausePending || isSubscriptionDisabled
      }
    ), this.state.activeModal === "pause" && subscription.pauseOptions.length > 0 && /* @__PURE__ */ React.createElement(
      PauseSubscriptionModal,
      {
        onCancel: this.closeModal,
        pauseDurationOptions: subscription.pauseOptions,
        onPause: this.handlePause,
        isLoading: statusLoading(pauseCall),
        errorMessage: this.state.pauseError
      }
    ), this.state.activeModal === "quantity" && /* @__PURE__ */ React.createElement(
      ChangeQuantityModal,
      {
        onCancel: this.closeModal,
        maxQuantity: 3,
        onEditQuantity: this.handleEdit,
        isLoading: statusLoading(quantityCall),
        errorMessage: this.state.quantityError,
        totalPricePerInstallment: subscription.billing.totalPricePerInstallment
      }
    ));
  }
}
function renderPendingChangesAlert(pendingChanges, intl) {
  if (pendingChanges.length < 1) {
    return;
  }
  if (pendingChanges.length > 1) {
    return /* @__PURE__ */ React.createElement(Alert, { key: "multiple", variant: "info", className: "alert-m-default" }, intl.getFormattedLabel(`account.ccc.pauseAndQuantity.processing`, {
      parseLink: true
    }));
  }
  const type = pendingChanges[0];
  return /* @__PURE__ */ React.createElement(Alert, { key: type, variant: "info", className: "alert-m-default" }, intl.getFormattedLabel(`account.ccc.${type}.processing`, {
    parseLink: true
  }));
}
function renderStatusAlert(status, intl) {
  let message;
  switch (status) {
    case "CANCELLED":
    case "EXPIRED":
    case "PAUSED":
      message = intl.getFormattedLabel(`account.ccc.${status.toLowerCase()}`, {
        parseLink: true
      });
      break;
    case "PENDING":
    case "ACTIVE":
      break;
    case "ON_HOLD":
      message = intl.getFormattedLabel(`account.ccc.onHold`, { parseLink: true });
      break;
  }
  return message && /* @__PURE__ */ React.createElement(Alert, { variant: "error", notifyScreenReader: false, className: "alert-m-default" }, message);
}
export {
  CurrentPlan
};
//# sourceMappingURL=CurrentPlan.js.map
